import './facts.scss';

import FadeIn from '../../../components/animation/fadeIn';
import Category from "../../../components/category/category";

export default function Facts() {
    return (
        <section id="Facts">
            <Category>Facts</Category>
            <FadeIn animateFrom={{ y: '300', opacity: '0' }} animateTo={{ y: '0', opacity: '1' }} onView={ true } rootMargin='10px' threshold={ 0.1 } delay={ 100 } transitionDuration={ 1000 } className='list' childTag='ol'>
                <ol>
                    <li><span>1.</span><p className="article-information">The planet's fastest land animal is built for super speed, rather than stamina</p></li>
                    <li><span>2.</span><p className="article-information">When they do stir, cheetahs can accelerate faster than most sports cars</p></li>
                    <li><span>3.</span><p className="article-information">The name cheetah comes from a Hindi word, chita, meaning 'spotted one'</p></li>
                    <li><span>4.</span><p className="article-information">Cheetahs have a unique social life among cats</p></li>
                    <li><span>5.</span><p className="article-information">Unlike most cats, the cheetah mainly hunts in the day</p></li>
                </ol>
                <ol>
                    <li><span>6.</span><p className="article-information">Don't expect a cheetah to roar. Cheetahs only meow!</p></li>
                    <li><span>7.</span><p className="article-information">In ancient Egypt the cheetah was considered sacred and a symbol of royalty</p></li>
                    <li><span>8.</span><p className="article-information">Cheetahs need their space. They prefer big areas.</p></li>
                    <li><span>9.</span><p className="article-information">Cheetahs are under threat from the illegal wildlife trade</p></li>
                    <li><span>10.</span><p className="article-information">Cheetahs could be sprinting towards extinction. Their numbers are decreasing...</p></li>
                </ol>
            </FadeIn>
        </section>
    );
};